<template>
  <footer
    class="footer"
    style="background: #F6F9FC"
  >
    <div class="container">
      <div class="row row-grid align-items-center my-md">
        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">
            Thank you for supporting us!
            <img
              src="https://user-images.githubusercontent.com/7906289/45718714-09330200-bb6c-11e8-8a60-5da580086a5f.png"
              alt="logo"
              height="30"
            />
          </h3>
          <h4 class="font-weight-light inline-text mr-5">What are you waiting for?</h4>
          <h6
            class="mb-0 font-weight-light inline-text mr-5"
          >Run our quick start demo and get from scratch to real data processing results in real data in 10-minutes.</h6>
          <base-button
            tag="a"
            href="https://isabl.gitbook.io/docs/quick-start"
            class="mt-5 pa-5"
            type="primary"
          >Go to 10-minutes to Isabl</base-button>
          <!-- href="https://mailchi.mp/d48670944ca4/isabl" -->
          <base-button
            tag="a"
            href="https://bmcbioinformatics.biomedcentral.com/articles/10.1186/s12859-020-03879-7"
            class="mt-5 pa-5"
            type="white"
          >See Isabl Platform paper</base-button>
        </div>
        <div class="col-lg-6 text-lg-center btn-wrapper">
          <a
            target="_blank"
            rel="noopener"
            href="https://twitter.com/PapaemmanuilLab"
            class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
            <font-awesome-icon :icon="['fab', 'twitter']" />
          </a>
          <a
            target="_blank"
            rel="noopener"
            href="https://github.com/isabl-io"
            class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Star us"
          >
            <font-awesome-icon :icon="['fab', 'github']" />
          </a>
          <a
            target="_blank"
            rel="noopener"
            href="mailto:papaemme@mskcc.org"
            class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round"
            data-toggle="tooltip"
            data-original-title="Email us"
          >
            <font-awesome-icon icon="envelope-open" />
          </a>
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; {{year}}
            <a
              href="http://isabl.com"
              target="_blank"
              rel="noopener"
            >Isabl Inc.</a> &
            <a
              href="https://www.mskcc.org/research-areas/labs/elli-papaemmanuil"
              target="_blank"
              rel="noopener"
            >Papaemmanuil Lab</a>
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <a
                href="https://isabl.io/docs"
                class="nav-link"
                target="_blank"
                rel="noopener"
              >Docs</a>
            </li>
            <li class="nav-item">
              <a
                href="https://www.mskcc.org/research-areas/labs/elli-papaemmanuil"
                class="nav-link"
                target="_blank"
                rel="noopener"
              >
                About
                Us
              </a>
            </li>
            <li class="nav-item">
              <a
                href="https://github.com/isabl-io"
                class="nav-link"
                target="_blank"
                rel="noopener"
              >Github</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style>
</style>
